module.exports = __webpack_public_path__ + "img/OXE - JDO 1816 x1000 V2.50d99c1f.png";